<template>
  <div class="wrapper-fashion">
    <MenuComponent
      logoUrl="assets/logos/LogoPurple.svg"
      textColor="var(--purple)"
      menuIcon="assets/icons/MenuPurple.svg"
      closeIcon="assets/icons/ClosePurple.svg"
    />

    <div class="wrapper-general">
      <p class="title">FOTOGRAFÍA EDITORIAL</p>
      <p class="subtitle">
        Imágenes que elevan la narrativa y posicionan tu marca
      </p>
      <div class="container">
        <div v-for="(image, index) in images" :key="index">
          <img :src="image.src" :alt="image.alt" class="file" />
        </div>
      </div>
    </div>

    <FooterComponent overlayColor="var(--purple)" />
  </div>
</template>

<script>
import MenuComponent from "@/ux/layout/components/MenuComponent.vue";
import FooterComponent from "@/ux/layout/components/FooterComponent.vue";
import { editorialGallery } from "@/data/fashion/editorialGallery.js";

export default {
  name: "EditorialGalleryView",
  components: {
    MenuComponent,
    FooterComponent,
  },

  data() {
    return {
      images: editorialGallery,
    };
  },
};
</script>

<style scoped lang="scss">
@import "src/ux/fashion/styles/fashionGalleryStyle";
</style>
